import { Class } from '../models/Class';

/**
 * Whether a class with the same name + section already exists at the given site.
 * The combination of name and section must be unique per site, so an empty
 * section still collides with another empty-section class of the same name.
 */
export function classNameSectionExists(
  classes: Class[],
  name: string,
  section: string,
  siteId: string | undefined,
): boolean {
  if (!siteId) return false;
  const normalizedName = name.trim().toLowerCase();
  const normalizedSection = section.trim().toLowerCase();

  return classes.some(
    cls =>
      cls.site?.id === siteId &&
      (cls.name ?? '').trim().toLowerCase() === normalizedName &&
      (cls.section ?? '').trim().toLowerCase() === normalizedSection,
  );
}
